import $ from 'jquery';

const datatables = {
    table: null,
    button: null,
    column: null,
    value: null,
    search: null,

    // HTML escape function to prevent XSS
    escapeHtml: function(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    },

    // Register DOM event bindings (formerly in $(function(){ ... }))
    async register() {
        $(() => {
            // Add new button clicked
            $(document).on('click', '.dt-add-new-btn', function() {
                window.dispatchEvent(
                    new CustomEvent('app:navigate', { detail: $(this).data('href') })
                );
                return false;
            });

            // Hide popovers when they're clicked on outside
            $('*').on('click', function(e) {
                if (! $(e.target).hasClass('datatable-filter-btn') &&
                    ! $(e.target).closest('.popover.datatable-filter').length) {
                    $('.datatable-filter-btn').popover('hide');
                }
            });

    // The filter popover has been shown
    /*
    $(".datatable-filter-btn").on('shown.bs.popover', function () {
        $('.datatable-filter:visible').val(datatables.value).focus();
    });
    */

            // Bind the filter change
            $(document).on('keyup change', 'input.datatable-filter', function() {
                datatables.search = $(this).val();

                if (datatables.button) {
                    datatables.button.data('filter', datatables.search).removeClass('active');
                    if (datatables.search) {
                        datatables.button.addClass('active');
                    }
                } else {
                    console.warn('No datatables.button defined');
                }

                if (datatables.table != null && datatables.column != null) {
                    datatables.table.column(datatables.column + ':visIdx')
                        .search(datatables.search, true, true)
                        .draw();
                } else {
                    console.warn('No datatables.table or datatables.column defined', {table: datatables.table, column: datatables.column} );
                }
            });

            // Filter column clear button clicked
            $(document).on('click', '.popover.datatable-filter span.field-clear', function() {
                $(this).closest('.btn-group').find('input').val('').focus().trigger('change');
            });
        });
    },
    /**
     * Build the datatable
     */
    init: function (table, options = null) {
        // Destroy the datatable if we have one already
        this.reset(table, false);

        // Adjust the column widths based on headers ----------------------------------------------
        var widths = [];
        table.find('thead th').each(function() {
            if ($(this).attr('width')) {
                widths.push($(this).attr('width'));
            } else {
                widths.push(0);
            }

            // Remove extra html from column header
            $(this).find('*').remove();
        });

        table.find('tbody tr').each(function() {
            var row = $(this);
            $(widths).each(function(index) {
                if (this != 0) {
                    row.find('td').eq(index).attr('width', this);
                }
            });
        });
        // ----------------------------------------------------------------------------------------

        options['bInfo'] = true;
        options['dom']= 'lftipB';
        options['colReorder'] = true;

        options['search'] = {
            regex: true,
            smart: false
        };

        /*
        options['language'] = {
            "emptyTable": "No records found"
        };
        */

        // Remove the specified columns by default
        if (options['remove']) {
            $(options['remove']).each(function() {
                var _index = this;
                table.find('th:eq(' + _index + ')').addClass('noVis removeCol');

                /*
                options['columnDefs'] = options['columnDefs'] || [];
                options['columnDefs'].push({
                    "targets": [_index],
                    "visible": false,
                    "orderable": false,
                });
                */

                // Update the column's visibility in localstorage
                datatables.saveColumnVisiblity(table, _index, false);
            });
        }

        options['deferRender'] = true;
        //options['scrollY'] = 150;
        options['scrollCollapse'] = true;
        options['scroller'] = true;

        options['buttons'] = [
            //'colvis', 'csv', 'excel', 'pdf',

            {
                extend: 'colvis',
                columns: ':not(.noVis)'
            }, {
                extend: 'csv',
                title: '',
                //messageTop: 'The information in this table is copyright to Retail Insights LLC',
                exportOptions: {
                    //columns: ':visible'
                    columns: function (idx, data, node) {
                        var table_id = node.getAttribute('aria-controls');
                        return $('#' + table_id).DataTable().column(idx).visible();
                    }
                }
            }, {
                extend: 'excel',
                title: '',
                //messageTop: 'The information in this table is copyright to Retail Insights LLC',
                exportOptions: {
                    //columns: ':visible'
                    columns: function (idx, data, node) {
                        var table_id = node.getAttribute('aria-controls');
                        return $('#' + table_id).DataTable().column(idx).visible();
                    }
                }
            }, {
                extend: 'pdf',
                title: '',
                //messageTop: 'The information in this table is copyright to Retail Insights LLC',
                exportOptions: {
                    //columns: ':visible'
                    columns: function (idx, data, node) {
                        var table_id = node.getAttribute('aria-controls');
                        return $('#' + table_id).DataTable().column(idx).visible();
                    }
                }
            },

	        //'copy',
            //'print',
	    ];

        // We're using server-side execution
        if (options['ajax']) {
            //options['buttons'] = ['csv'];
        }

        // Apply responsive options
        if (options['responsive'] === undefined) {
            options['responsive'] = {
                details: {
                    renderer: $.fn.dataTable.Responsive.renderer.listHiddenNodes()
                    //renderer: $.fn.dataTable.Responsive.renderer.tableAll()
                }
            };
        }

        // Apply the saved column visiblity
        options = this.applyColumnVisiblity(table, options);

        this.table = table.DataTable(options);

        this.table.on('draw', function () {
            var body = $(datatables.table.table().body());
            var global_search = datatables.table.search();

            body.unhighlight();
            if (global_search) {
                //body.unhighlight();
                body.highlight(global_search);
            }

            table.find('tr:visible').each(function() {
                var column = $(this).find('td').eq(datatables.column);
                column.unhighlight();

                if (datatables.search) {
                    column.highlight(datatables.search);
                }
            });
        });

        // Colvisible callback
        this.table.on('column-visibility.dt', function(e, settings, column, state) {
            datatables.saveColumnVisiblity(table, column, state);
        });

        // TODO: enable this for ajax
        if (!options['ajax']) {
            var _this = this;

            // Popover input field filters
            table.find('thead th').not('.sorting_disabled, .dropdown-filter').each(function() {
                //fa-filter
                $(this).find('div').remove(); // Remove any existing divs
                $(this).append('<i class="fa fa-caret-down datatable-filter-btn pl-2" title="Filter ' + datatables.escapeHtml($(this).text()) + '"></i>');
            });

            // Dropdown filters
            table.find('thead th.dropdown-filter').not('.sorting_disabled').each(function() {
                $(this).find('div').remove(); // Remove any existing divs
                var select = $('<div class="dropdown-menu"></div>');

                _this.table.column($(this).index() + ':visIdx').data().unique().sort().each(function(d, j) {
                    d = d.replace(/(<([^>]+)>)/ig,"").trim();
                    if (d) {
                        select.append('<a class="dropdown-filter dropdown-item" href="#" data-value="(^' + d + ')">' + d + '</a>');
                    }
                });

                $(this).append('<div class="btn-group"><i class="fa fa-caret-down dropdown-filter pl-2" data-toggle="dropdown" title="Filter ' + datatables.escapeHtml($(this).text()) + '"></a>' + '</div>');
                $(this).find('.btn-group').append(select);
            });
        }

        // Apply the column filter click event (must be done non-globally to stop propagation)
        $('.datatable-filter-btn').off('click').on('click', function(e) {
            e.stopPropagation();
            $('.datatable-filter-btn').popover('hide');
            datatables.showFilter($(this));
        });

        // Apply the column filter dropdown click event (must be done non-globally to stop propagation)
        $('th i.dropdown-filter').off('click').on('click', function(e) {
            e.stopPropagation();

            // Fix for weird bootstrap dropdown issue
            if (!$(this).data('dropdown-init')) {
                $(this).dropdown('show');
                $(this).data('dropdown-init', true);
            } else {
                $(this).dropdown();
            }
        });

        // Toggle dropdown filters
        $('a.dropdown-filter.dropdown-item').off('click').on('click', function(e) {
            e.stopPropagation();
            var header = $(this).closest('th');
            //header.find('a.dropdown-filter.dropdown-item').removeClass('active').addClass('in-active');
            header.find('a.dropdown-filter.dropdown-item').not('.active').addClass('in-active');

            let search;
            if ($(this).hasClass('active')) {
                search = header.data('filter');
                search = search.replace($(this).data('value') + '|', '').trim();
                search = search.replace($(this).data('value'), '').trim();

                // Remove trailing | to prevent regex problems
                if (search[search.length -1] == '|') {
                    search = search.substring(0, search.length - 1);
                }

                header.data('filter', search);

            } else {
                search = header.data('filter') ? header.data('filter') + '|' : '';
                search = search + $(this).data('value');
                header.data('filter', search);
            }

            $(this).toggleClass('active').toggleClass('in-active');

            // Nothing is selected, restore back to default
            if (header.find('a.dropdown-filter.dropdown-item.active').length == 0) {
                header.find('a.dropdown-filter.dropdown-item').removeClass('in-active');
                header.find('i.dropdown-filter').removeClass('active');

            } else {
                header.find('i.dropdown-filter').addClass('active');
            }

            //console.log(search);
            datatables.table.column(header.index() + ':visible').search(search.trim(), true, true).draw();
        });


        // Move the export buttons --------------------------------------------------------------------
        var tableWrapper = table.closest('.dataTables_wrapper');
        // Format the dom info into bootstrap rows and columns
        //tableWrapper.find('.dataTables_length').parent().addClass('row');
        tableWrapper.find('.dataTables_length, .dataTables_filter').wrapAll("<div class='row'></div>");
        tableWrapper.find('.dataTables_info, .dataTables_paginate').wrapAll("<div class='row'></div>");

        tableWrapper.find('.dataTables_length').addClass('col-4'); // Pagination column
        tableWrapper.find('.dataTables_filter').addClass('col-8'); // Search/Buttons columns
        tableWrapper.find('.dataTables_info, .dataTables_paginate').addClass('col-6'); // Info and pagination buttons columns

        // Clone default buttons
        var btns = tableWrapper.find('.dt-buttons').addClass('ml-4');

        // Format the buttons
        btns.find('.btn-secondary').removeClass('btn-secondary').addClass('btn-outline-secondary btn-sm');
        btns.find('.buttons-copy').attr('title', 'Copy Table to Clipboard').prepend('<i class="far fa-clipboard mr-2"></i>');
        btns.find('.buttons-csv').attr('title', 'Export to CSV').prepend('<i class="fas fa-file-csv mr-2"></i>');
        btns.find('.buttons-excel').attr('title', 'Export to Excel').prepend('<i class="far fa-file-excel mr-2"></i>');
        btns.find('.buttons-pdf').attr('title', 'Export to PDF').prepend('<i class="far fa-file-pdf mr-2"></i>');
        btns.find('.buttons-colvis').attr('title', 'Column Visibility').prepend('<i class="far fa-eye mr-1"></i>').find('span').remove();
        //btns.find('.buttons-colvis').removeClass('dropdown-toggle');

        // We're using server-side execution
        if (options['ajax']) {
            //btns.find('.buttons-excel, .buttons-pdf').hide();
            btns.find('.buttons-excel, .buttons-pdf').attr('disabled', true);

            btns.find('.buttons-csv').off('click').on('click', function() {
                var data = datatables.table.ajax.params();
                window.location.href = options['ajax'] + '?action=EXPORT_CSV&' + $.param(data);
            });
        }

        tableWrapper.find('.dataTables_filter').append(btns);

        // Add the "Add New" button
        if (options['addBtn']) {
            tableWrapper.find('.dataTables_filter').append('<a href="#" data-href="' + options['addBtn'] + '" class="btn btn-primary btn-sm ml-2 dt-add-new-btn">Add New</a>');
        }

        // Add the "Add New" button linked to a modal
        if (options['addBtnModal']) {
            tableWrapper.find('.dataTables_filter').append('<button class="btn btn-primary btn-sm ml-2" data-toggle="modal" data-target="' + options['addBtnModal'] + '">Add New</button>');
        }
        // --------------------------------------------------------------------------------------------


        table.show();
        table.resize();
        //table.disableSelection();

        this.table.on('responsive-display', function (e, datatable, row, showHide, update) {
            // The row was shown
            if (showHide) {
                var detailsRow = $(row.node()).next();
                var maxWidth = 0;

                // Find the widest title element
                detailsRow.find('span.dtr-title').each(function() {
                    if ($(this).width() > maxWidth){
                        maxWidth = $(this).width();
                    }
                });

                // We have a max width
                if (maxWidth > 0) {
                    detailsRow.find('span.dtr-title').width(maxWidth + 20);
                }
            }
        });

        return datatables.table;
    },


    /**
     * Destory the datatable if we have one already
     */
    reset: function(table, killVals = true) {
        if (table.DataTable() instanceof $.fn.dataTable.Api) {
        //if (table.DataTable.destroy) {
            table.DataTable().destroy();
        }

        table.find('.datatable-filter-btn').remove();
        table.hide();

        if (killVals) {
            table.find('tbody tr').remove();
        }
    },


    /**
     * Show the filter popover
     */
    showFilter: function(button) {
        // var table = button.closest('table.datatable');

        //datatables.column = table.find('.datatable-filter-btn').index(button);
        datatables.column = button.closest('th').index();
        //datatables.button = table.find('.datatable-filter-btn').eq(datatables.column);
        datatables.button = button.closest('.datatable-filter-btn');
        datatables.value = datatables.button.data('filter') || '';

        //button.popover('destroy');
        button.popover({
            container: 'body',
            trigger: 'manual',
            placement: 'top',
            html: true,
            sanitize: false,
            template: '<div class="popover datatable-filter" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
            //content: '<input type="text" class="datatable-filter form-control" value="' + datatables.value + '" placeholder="">',
            content: '<div class="btn-group datatable-filter-group"><input type="text" class="datatable-filter form-control" value="' + datatables.value + '" placeholder=""><span class="field-clear fa fa-times-circle"></span></div>',
        });

        button.popover('show');

        setTimeout(function() {
            $('.datatable-filter:visible').val(datatables.value).focus();
        }, 50);
    },


    /**
     * Apply column visibility to the specified options object
     *
     * @param {*} options
     */
    applyColumnVisiblity: function(table, options) {
        var keyName = datatables.columnsKey(table);
        var savedColumns = window.localStorage.getItem(keyName) ? JSON.parse(window.localStorage.getItem(keyName)) : [];
        // var columns = table.find('thead th');

        var hiddenColumns = $.map(savedColumns, function(val, i) {
            //console.log(i + ' -- ' + columns.eq(i).hasClass('noVis'));

            /*
            if (columns.eq(i).hasClass('noVis')) {
                return val.id;
            }
            */

            return !val.visible ? val.id : null;
        });

        // Find manually hidden columns
        table.find('thead th').each(function(index) {
            if ($(this).hasClass('noVis')) {
                //if (!$.inArray(hiddenColumns, index)) {
                    hiddenColumns.push(index);
                //}
            }
        });

        // var visibleColumns = $.map(savedColumns, function(val, i) {
        //     return val.visible ? val.id : null;
        // });

        // TODO: enable visible columns and check for existing columnDefs to overwrite

        //alert(JSON.stringify(hiddenColumns) + '\n' + JSON.stringify(visibleColumns));

        if ($(hiddenColumns).length) {
            if (!options['columnDefs']) {
                options['columnDefs'] = [];
            }

            options['columnDefs'].push({
                "targets": hiddenColumns,
                "visible": false
            });
        }

        /*
        if ($(visibleColumns).length) {
            if (!options['columnDefs']) {
                options['columnDefs'] = [];
            }

            options['columnDefs'].push({
                "targets": visibleColumns,
                "visible": true
            });
        }
        */

        return options;
    },

    /**
     * localStorage key for a table's saved column visibility. Saved state is by column index, so a table
     * whose columns shift sets data-columns-key to a new key rather than hiding the wrong columns.
     *
     * @param {*} table
     */
    columnsKey: function(table) {
        return table.data('columns-key') || table.attr('id') + '_columns';
    },

    /**
     * Save the column visibile state
     *
     * @param {*} table
     * @param {*} index
     */
    saveColumnVisiblity: function(table, index, visible) {
        var keyName = datatables.columnsKey(table);
        //window.localStorage.removeItem(keyName);
        var hiddenColumns = window.localStorage.getItem(keyName) ? JSON.parse(window.localStorage.getItem(keyName)) : [];

        // Remove the index value from the hiddenColumns array
        hiddenColumns = jQuery.grep(hiddenColumns, function(n) {
            return (n.id != index);
        });

        hiddenColumns.push({'id': index, 'visible': visible });

        //alert(JSON.stringify(hiddenColumns));
        window.localStorage.setItem(keyName, JSON.stringify(hiddenColumns));
    },
}


export default datatables;
